import D2C_ProviderStorage from './Storage'

class D2C_ProviderOneDrive extends D2C_ProviderStorage {
  static objectType = 'providerType'
  static active = true
  static order = 32
  static providerType = 'OneDrive'
  static providerTitle = 'Microsoft OneDrive'
  static oauth = true
  static fields = {
    ...D2C_ProviderStorage.fields,
    apiToken: {
      default: '',
      hidden: true,
      label: 'Token',
      path: 'auth.apiToken',
      required: true,
      validate(value) {
        return value ? null : 'Must be uploaded'
      },
      creating: {},
    },
    drive: {
      default: null,
      label: 'Drive ID',
      path: 'auth.accessId',
      required: true,
      validate(value) {
        return value ? null : 'Must be selected'
      },
      creating: {},
    },
  }
}

export default D2C_ProviderOneDrive
